// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const cardBlock = "Blocks__cardBlock__cn53P";
export const noBorders = "Blocks__noBorders__yc1Y8";
export const withPadding = "Blocks__withPadding__b2xW4";
export const withShadow = "Blocks__withShadow__p+OuH";
export const softShadow = "Blocks__softShadow__P3v0M";
export const mediumShadow = "Blocks__mediumShadow__vQFSp";
export const fullHeight = "Blocks__fullHeight__I5LRB";
export const notification = "Blocks__notification__6wr5E";
export const notificationInner = "Blocks__notificationInner__sW47s";
export const expanded = "Blocks__expanded__HJuU2";
export const forceRoundedCorners = "Blocks__forceRoundedCorners__HnhRP";
export const bottomCorners = "Blocks__bottomCorners__1NWrS";
export const topCorners = "Blocks__topCorners__CmagV";
export const allCorners = "Blocks__allCorners__N2BUz Blocks__bottomCorners__1NWrS Blocks__topCorners__CmagV";
export const noShadow = "Blocks__noShadow__T04M2";